import { MulticastDelegate1 } from "flavr-common";
import { BufferState, sharedArrayService } from "./SharedArrayService";
export class SharedBuffer {
    constructor(id, sharedType, createdTime, fromWorkerId, uId) {
        this.id = id;
        this.sharedType = sharedType;
        this.createdTime = createdTime;
        this.fromWorkerId = fromWorkerId;
        this.uId = uId;
        this.offset = 0;
        this.usingSharedArrayBuffer = false;
        this.needsResend = true;
        this.onDestroyedDelegate = new MulticastDelegate1();
    }
    get byteLength() {
        if (!this.buffer)
            return 0;
        return this.buffer.byteLength;
    }
    get isConsumed() {
        if (this.numDirtyArray && Atomics.load(this.numDirtyArray, 0) !== 0)
            return false;
        if (this.headerUintArray)
            return Atomics.load(this.headerUintArray, 0) !== BufferState.Ready;
        return true;
    }
    get numDirty() {
        if (this.numDirtyArray) {
            return Atomics.load(this.numDirtyArray, 0);
        }
        return 0;
    }
    destroy() {
        this.onDestroyedDelegate.invoke(this);
    }
    create(byteLength) {
        this.offset = 0;
        if (self.SharedArrayBuffer) {
            const headerByteLength = Uint32Array.BYTES_PER_ELEMENT * 2;
            this.buffer = new self.SharedArrayBuffer(byteLength + headerByteLength);
            this.headerUintArray = this.createDataArray(Uint32Array, 1);
            this.numDirtyArray = this.createDataArray(Uint32Array, 1);
            this.usingSharedArrayBuffer = true;
        }
        else {
            this.buffer = new ArrayBuffer(byteLength);
        }
    }
    getBuffer() {
        return this.buffer;
    }
    createDataArray(type, length) {
        if (!this.buffer)
            throw new Error("Buffer was not created");
        if (this.offset + type.BYTES_PER_ELEMENT * length > this.buffer.byteLength) {
            throw new Error(`Buffer overflow`);
        }
        const array = new type(this.buffer, this.offset, length);
        this.offset += type.BYTES_PER_ELEMENT * length;
        return array;
    }
    commit(numChanged) {
        if (!this.buffer)
            return false;
        if (!this.usingSharedArrayBuffer) {
            sharedArrayService.postBuffer(this);
        }
        if (!this.headerUintArray)
            return false;
        if (this.needsResend) {
            this.needsResend = false;
            sharedArrayService.postBuffer(this);
        }
        Atomics.store(this.headerUintArray, 0, BufferState.Ready);
        if (this.numDirtyArray && numChanged !== undefined) {
            Atomics.store(this.numDirtyArray, 0, numChanged);
        }
        return true;
    }
    onDestroy() {
        this.buffer = undefined;
        this.headerUintArray = undefined;
        this.numDirtyArray = undefined;
    }
}
